import React from "react";

function PrivacyPolicyPage() {
  return (
    <main className="privacy-page">
      <section className="privacy-card">
        <h1>Privacy Policy</h1>

        <p><strong>Last updated:</strong> May 2, 2026</p>

        <p>
          This website provides aviation-related calculators and preflight
          planning tools for informational and educational purposes.
        </p>

        <h2>Information We Collect</h2>
        <p>
          This site may collect limited non-personal information such as browser
          type, device type, pages visited, and general usage data. This
          information may be used to improve site performance and usability.
        </p>

        <h2>Cookies and Advertising</h2>
        <p>
          This site may use cookies, web beacons, IP addresses, or similar
          technologies through third-party services such as Google AdSense or
          Google Analytics. Third-party vendors, including Google, may use
          cookies to serve ads based on a user&apos;s prior visits to this site
          or other websites.
        </p>

        <p>
          Users may opt out of personalized advertising by visiting Google Ads
          Settings. Users may also opt out of some third-party vendors&apos; use
          of cookies for personalized advertising by visiting applicable
          industry opt-out pages.
        </p>

        <h2>Third-Party Links</h2>
        <p>
          This site may contain links to external websites. No responsibility is
          assumed for the privacy practices, content, or accuracy of third-party
          websites.
        </p>

        <h2>Data Security</h2>
        <p>
          Reasonable efforts are made to protect this website, but no method of
          transmission or storage is completely secure.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          This Privacy Policy may be updated from time to time. Any updates will
          be posted on this page with a revised date.
        </p>

        <h2>Contact</h2>
        <p>
          For questions about this Privacy Policy, use the contact information
          provided on the Contact page.
        </p>
      </section>
    </main>
  );
}

export default PrivacyPolicyPage;